import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';
import { Tabs, Tab, Dropdown, DropdownButton, MenuItem } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Tabs
import StaffEditTab from './Elements/StaffEditTab';
import StaffLicensesTab from './Elements/StaffLicensesTab';
import StaffRolesTab from './Elements/StaffRolesTab';
import StaffDesignationsTab from './Elements/StaffDesignationsTab';
import StaffPeriodsTab from './Elements/StaffPeriodsTab';
import StaffGratificationsTab from './Elements/StaffGratificationsTab';
import StaffIcaosTab from './Elements/StaffIcaosTab';
import StaffHoursTab from './Elements/StaffHoursTab';
import StaffClientsTab from './Elements/StaffClientsTab';
import StaffCertificationsTab from './Elements/StaffCertificationsTab';
import StaffIndicationsTab from './Elements/StaffIndicationsTab';
import StaffPaymentsTab from './Elements/StaffPaymentsTab';
import StaffVacationTab from './Elements/StaffVacationTab';
import StaffCertificationsTypeTab from './Elements/StaffCertificationsTypeTab';
import StaffRecordTab from './Elements/StaffRecordTab';
import StaffAdministrativeTab from './Elements/StaffAdministrativeTab';
import StaffProcessTab from './Elements/StaffProcessTab';
import StaffBasesTab from './Elements/StaffBasesTab';
import StaffCostsTab from './Elements/StaffCostsTab';
import StaffGuaranteedHoursTab from './Elements/StaffGuaranteedHoursTab';
import getLocale from '../../i18n/getLocale';


class SigtripStaffsEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      staff_data: {},
      staff_bases: {},
      staff_costs: {},
      staff_guaranteed_hours: {},
      processes_list: null,
      bases_list: null,
      training_certification_staff_payments_national: null,
      training_certification_staff_payments_international: null,
      training_certification_staff_payments_hours: null,
      flight_hours_totals: null,
      staff_flight_files: null,
      aircraft_models: null,
      designations: null,
      gratifications: null,
      certifications: null,
      staff_licenses: null,
      staff_roles: null,
      staff_designations: null,
      staff_periods: null,
      staff_regimes_select: null,
      staff_processes: null,
      staff_gratifications: null,
      staff_icaos: null,
      staff_clients: null,
      staff_certifications: null,
      staff_indications: null,
      staff_certifications_other_type: null,
      staff_record_files: null,
      roles: null,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.export = this.export.bind(this);
    this.openAnac = this.openAnac.bind(this);
    this.archive = this.archive.bind(this);
    this.restauration = this.restauration.bind(this);
    this.refreshData = this.refreshData.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    var id = null;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/portal/funcionario/sigtrip';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'redirect') {
          var url = '/portal/file/digital/sigmec/';
          self.setState({redirect_url: url});
        } else {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({staff_data: responseJson.data.main});
            self.setState({id: responseJson.data.main.id});
            id = responseJson.data.main.id;
            self.setState({staff_licenses: responseJson.data.staff_licenses});
            self.setState({staff_roles: responseJson.data.staff_roles});
            self.setState({staff_designations: responseJson.data.staff_designations});
            self.setState({staff_indications: responseJson.data.staff_indications});
            self.setState({staff_periods: responseJson.data.staff_periods});
            self.setState({staff_gratifications: responseJson.data.staff_gratifications});
            self.setState({staff_icaos: responseJson.data.staff_icaos});
            self.setState({staff_clients: responseJson.data.staff_clients});
            self.setState({staff_certifications: responseJson.data.staff_certifications});
            self.setState({staff_certifications_other_type: responseJson.data.staff_certifications_other_type});
            self.setState({flight_hours_totals: responseJson.data.flight_hours_totals});
            self.setState({staff_flight_files: responseJson.data.staff_flight_files});
            self.setState({adm_files: responseJson.data.adm_files});
            self.setState({staff_record_files: responseJson.data.staff_record_files});
            self.setState({staff_processes: responseJson.data.staff_processes});
            self.setState({training_certification_staff_payments_national: responseJson.data.training_certification_staff_payments_national});
            self.setState({training_certification_staff_payments_international: responseJson.data.training_certification_staff_payments_international});
            self.setState({staff_bases: responseJson.data.staff_bases});
            self.setState({staff_costs: responseJson.data.staff_costs});
            self.setState({staff_guaranteed_hours: responseJson.data.staff_guaranteed_hours});
            self.setState({training_certification_staff_payments_hours: responseJson.data.training_certification_staff_payments_hours});
          }
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      });
    });
  }

  export(url) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
          self.handleAlert('', '', 'closed');
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      });
    });
  }

  archive(event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    var url = '/demitir/funcionario/';
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url + self.state.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.refreshData(responseJson);
        }
      });
    });
  }

  restauration(event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    var url = '/restaurar/funcionario/';
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url + self.state.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.refreshData(responseJson);
        }
      });
    });
  }

  refreshData(event) {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    var url = config.get('api') + '/funcionario/'+self.state.id;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({staff_data: responseJson.data});
          self.handleAlert(event.message, event.status, 'open');
        }
      });
    });
  }

  openAnac(url) {
    window.open(this.state.staff_data.url_anac);
  }

  render() {
    return (
<div>
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.ColaboradoresSigtrip.EditarFuncionario.titulo} - {this.state.staff_data.name}</h3>
      {/* <div className="grid-buttons pull-right">
        <Dropdown id="export-data">
          <Dropdown.Toggle bsStyle={'primary'}>
            <i className="fa fa-fw fa-file-pdf-o"></i> Exportações
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <MenuItem header>Geral</MenuItem>
            <MenuItem onSelect={this.openAnac} eventKey={'/portal/exportar/declaracao/funcionario/'}>ANAC</MenuItem>
            <MenuItem divider />
            <MenuItem header>Certificações</MenuItem>
            <MenuItem onSelect={this.export} eventKey={'/portal/exportar/certificacoes/funcionario/filtered'}>Visualizar</MenuItem>
            <MenuItem divider />
            <MenuItem header>Currículo</MenuItem>
            <MenuItem onSelect={this.export} eventKey={'/portal/exportar/curriculo/funcionario/pt-br'}>Visualizar PT-BR</MenuItem>
            <MenuItem onSelect={this.export} eventKey={'/portal/exportar/curriculo/funcionario/en-us'}>Visualizar EN-US</MenuItem>
          </Dropdown.Menu>
        </Dropdown>
      </div> */}
      <div className="clearfix"></div>
      <hr/>
      <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
        <Tab eventKey={1} title={this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.tituloTab}>
          <StaffEditTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_data={this.state.staff_data} />
        </Tab>
        <Tab eventKey={3} title={this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHorasDeVoo.tituloTab}>
          <StaffHoursTab RequestApi={this.refs.request_api} handleAlert={this.handleAlert} staff_id={this.props.match.params.id} flight_hours_totals={this.state.flight_hours_totals} staff_flight_files={this.state.staff_flight_files} />

        </Tab>
        <Tab eventKey={4} title={this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHabilitacoes.tituloTab}>
          <StaffLicensesTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} aircraft_models={this.state.aircraft_models} staff_licenses={this.state.staff_licenses} />
        </Tab>
        {/* <Tab eventKey={8} title="FIRA">
          <StaffRecordTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_record_files={this.state.staff_record_files} />
        </Tab> */}
        <Tab eventKey={9} title={this.locale.ColaboradoresSigtrip.EditarFuncionario.tabCargos.tituloTab}>
          <StaffRolesTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_roles={this.state.staff_roles} roles={this.state.roles} />
        </Tab>
        <Tab eventKey={10} title={this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDesignacoes.tituloTab}>
          <StaffDesignationsTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_designations={this.state.staff_designations} designations={this.state.designations} aircraft_models={this.state.aircraft_models} />
        </Tab>
        <Tab eventKey={11} title={this.locale.ColaboradoresSigtrip.EditarFuncionario.tabIndicacoes.tituloTab}>
          <StaffIndicationsTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_indications={this.state.staff_indications} designations={this.state.designations} aircraft_models={this.state.aircraft_models} />
        </Tab>
        {/* <Tab eventKey={16} title="Pagamentos">
          <StaffPaymentsTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_data={this.state.staff_data} training_certification_staff_payments_national={this.state.training_certification_staff_payments_national} training_certification_staff_payments_international={this.state.training_certification_staff_payments_international}training_certification_staff_payments_hours={this.state.training_certification_staff_payments_hours} />
        </Tab> */}
        {/* <Tab eventKey={17} title="Férias">
          <StaffVacationTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_data={this.state.staff_data} />
        </Tab> */}
        {/* <Tab eventKey={19} title="Centro de custo">
          <StaffCostsTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_costs={this.state.staff_costs} />
        </Tab> */}
        {/* <Tab eventKey={20} title="Horas garantidas">
          <StaffGuaranteedHoursTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_guaranteed_hours={this.state.staff_guaranteed_hours} />
        </Tab> */}
      </Tabs>
    </div>
  </div>
</div>
    );
  }
}

export default SigtripStaffsEdit;




// WEBPACK FOOTER //
// ./src/Components/SigtripStaffs/SigtripStaffsEdit.js